<template>
    <sub-page class="m-addPaper m-addFiscanPaper">
        <el-steps class="step-title" :active="active" finish-status="success" simple style="padding: 12px 20%;">
            <div class="click-zone" @click="toStep(0)"></div>
            <div class="click-zone" @click="toStep(1)"></div>
            <el-step :title="$t('course.addBaseInfo')" icon="el-icon-edit"></el-step>
            <el-step :title="$t('paper.startPaper')" icon="el-icon-tickets"></el-step>
        </el-steps>

        <transition enter-active-class="animated slideInRight">
            <div class="step-box step-1" v-show="active === 0">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-width="$i18n.locale === 'zh-CN' ? '100px': '140px'" class="paper-form">
                    <el-row class="paper-form-row">
                        <el-col :span="8" class="col-flow">
                            <el-form-item :label="$t('paper.name')" prop="title">
                                <el-input v-model="ruleForm.title" :placeholder="$t('tip.paperName')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="col-flow">
                            <el-form-item :label="$t('paper.form')" prop="form">
                                <el-select v-model="ruleForm.form" :placeholder="$t('tip.paperForm')">
                                    <el-option :label="item.value" :value="item.id" v-for="item in patterns"
                                               :key="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="col-flow">
                            <el-form-item :label="$t('c.knowledgePoint')" prop="knowledge">
                                <el-cascader
                                    v-model="ruleForm.knowledge"
                                    :options="knowledgeMenu['Image']"
                                    :props="cascadeProp"
                                    :placeholder="$t('tip.knowledgePoint')"
                                    :show-all-levels="false"
                                    @change="knowledgeChange"
                                    filterable
                                ></el-cascader>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="paper-form-row">
                        <el-col :span="8" class="col-flow">
                            <el-form-item :label="$t('c.operatorLevel')" prop="forLevel">
                                <el-select v-model="ruleForm.forLevel" collapse-tags :placeholder="$t('tip.operatorLevel')">
                                    <el-option :label="item.value" :value="item.id" v-for="item in forLevelMenu" :key="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="col-flow">
                            <el-form-item :label="$t('c.difficulty')" prop="difficulty">
                                <el-select v-model="ruleForm.difficulty" :placeholder="$t('tip.difficulty')">
                                    <el-option :label="item.value" :value="item.id" v-for="item in difficultyDict"
                                               :key="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="col-flow">
                            <el-form-item :label="$t('topic.passLine')" prop="passLine">
                                <el-input-number v-model.number="ruleForm.passLine" controls-position="right" :min="0.1" :max="1" :precision="2" :step="0.1"></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <div class="btn-group">
                    <el-button type="primary" @click="nextStep('ruleForm')"
                               style="padding: 12px 50px;">{{$t('c.next')}}
                    </el-button>
                </div>
            </div>
        </transition>

        <transition enter-active-class="animated slideInLeft">
            <div class="step-box step-2" v-show="active === 1">

                <component
                    :is="componentName"
                    :form-data="ruleForm"
                    :paper-detail="paperDetail"
                    @last-step="lastStep"
                    @needUpdate="needUpdate"
                />
            </div>

        </transition>

    </sub-page>
</template>

<script>
/**
 * todo:
 * 1、对接接口、编辑模式填充考卷信息
 */
import {mapGetters} from 'vuex'
import {Cascade} from '@/utils'
import AddFiscanByAuto from "./Fiscan/AddFiscanByAuto";
import EditFiscanPaper from "./Fiscan/EditFiscanPaper";

export default {
    components: {
        AddFiscanByAuto,
        EditFiscanPaper
    },

    props: ['paperId'],

    data() {
        return {
            active: 0,
            componentName: '',
            ruleForm: {
                title: '',
                knowledge: [],
                forLevel: '',
                form: '',
                difficulty: '',
                passLine: 0.6,
            },
            rules: {
                title: [
                    {required: true, message: this.$t('tip.name'), trigger: 'blur'},
                    {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                ],
                knowledge: [
                    {required: true, message: this.$t('tip.knowledgePoint'), trigger: 'change'}
                ],
                forLevel: [
                    {required: true, message: this.$t('tip.operatorLevel'), trigger: 'change'}
                ],
                form: [
                    {required: true, message: this.$t('tip.paperForm'), trigger: 'change'}
                ],
                difficulty: [
                    {required: true, message: this.$t('tip.difficulty'), trigger: 'change'}
                ],
                passLine: [
                    {type: 'number', required: true, message: this.$t('tip.passLine'), trigger: 'blur'},
                ],
            },
            cascadeProp: {
                value: 'id',
                label: 'value',
                children: 'children'
            },
            difficultyDict: [],
            patterns: [],
            isEdit: false,
            paperDetail: {},
        }
    },

    computed: {
        ...mapGetters([
            'forLevelMenu',
            'knowledgeMenu'
        ]),
    },

    mounted() {
        // this.$store.dispatch('getForLevelMenu')
        this.$store.dispatch('getKnowledgeMenu', {
            type: 'Image'
        }).then(data => {
            if(this.paperId){
                this.isEdit=true
                this.initData()
            } else {
                this.componentName = 'AddFiscanByAuto'
            }
        })

        this.$api.getDifficulty().then(res => {
            this.difficultyDict = res.package;
        })
        this.$api.getPaperPattern().then(res => {
            this.patterns = res.package;
        })
    },

    methods: {
        initData() {
            this.$api.getFiscanPaperDetail(this.paperId).then(res => {
                const data = res.package
                this.paperDetail = data

                for (let item in data) {
                    if (this.ruleForm.hasOwnProperty(item)) {
                        this.ruleForm[item] = data[item]
                    }
                }

                this.ruleForm.knowledge = Cascade.fullPath(this.knowledgeMenu['Image'], data.knowledge)

                this.componentName = 'EditFiscanPaper'
            })
        },

        toStep(n) {
            if (this.isValid()) {
                this.active = n;
            }
        },
        lastStep() {
            this.active--
        },
        nextStep() {
            if (this.isValid()) {
                this.active++
            }
        },

        isValid() {
            let bool = true

            if (this.active === 0) {
                this.$refs['ruleForm'].validate((valid) => {
                    if (!valid) {
                        return bool = false
                    }
                });
            }

            return bool
        },

        //知识点变化
        // knowledgeChange(data){
        //     this.ruleForm.knowledge=data;
        // },

        needUpdate() {
            this.$emit('needUpdate')
        }
    },
}
</script>

<style lang="scss">
@import "./AddPaper";

.viewer-fiscanImage {
    .viewer-canvas img {
        background-color: #fff;
    }
}
</style>
